import { useContext } from "react";
import { ImportResultsAction } from "../actions";
import { AccessPointProcessingResult, AccessPointProcessingStep } from "../models";
import { ProviderNetworkImportContext } from "../providerNetworksImportContext";
import ProviderNetworkImportService from "../services/providerNetworkImportService";

interface UseImportResultsReturnType {
  getResult: (step: AccessPointProcessingStep) => AccessPointProcessingResult;
  isResultsLoading: boolean;
  loadResults: (versionId: number) => Promise<void>;
  exportResultsAsExcel: (versionId: number) => Promise<void>;
}

export function useImportResults(): UseImportResultsReturnType {
  const { resultsDispatch, results } = useContext(ProviderNetworkImportContext);
  const importService = new ProviderNetworkImportService();

  const loadResults = async (versionId: number) => {
    resultsDispatch({ type: ImportResultsAction.LoadResults, versionId });
    const result = await importService.getLatestProcessingResults(versionId);
    resultsDispatch({ result, type: ImportResultsAction.LoadResultsSuccess });
  };

  const getResult = (step: AccessPointProcessingStep) => {
    if (step in results.results) {
      return results.results[step];
    }
    return null;
  };

  const exportResultsAsExcel = async (versionId: number) => {
    const result = await importService.getExportResults(versionId);
    window.open(result, "_blank");
  };

  const isResultsLoading = results.isLoading;

  return { exportResultsAsExcel, getResult, isResultsLoading, loadResults };
}
